package com.parmartechnologies.core.feature.businessType.model

import com.parmartechnologies.core.extension.BaseDataClass
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.ExperimentalTime

@Serializable
data class BusinessType @OptIn(ExperimentalTime::class) constructor(
    @SerialName("name") var name: String = "",
    @SerialName("description") var description: String = "",
    @SerialName("image") var image: ArrayList<String> = arrayListOf(),
    @SerialName("business_type_id") var businessTypeID: Int = 0,
): BaseDataClass()